import React from 'react'

export default function Video() {
    return (
        <div className = "Video">
            <div className = "Video-container">
                <div className="fb-video"
                data-href="https://www.facebook.com/CabrerasMexicanRestaurant/videos/try-something-new-at-cabreras/482818229033216/?__so__=channel_tab&__rv__=related_videos"
                data-width="900"
                data-allowfullscreen="true"
                data-autoplay="false"
                data-show-captions="true"></div>
            </div>
        </div>
    )
}
